import { useEffect, useRef } from "react";
import { useAuthStore } from "@/stores/auth-store";

const IDLE_TIMEOUT_MS = 5 * 60 * 1000; // 5 minutes

export function useIdleTimeout() {
  const logout = useAuthStore((state) => state.logout);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (!isAuthenticated) return;

    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        // Keycloak logout handles the redirect automatically
        logout();
      }, IDLE_TIMEOUT_MS);
    };

    const events = ["mousemove", "keydown", "mousedown", "touchstart", "scroll"];
    events.forEach((event) => document.addEventListener(event, resetTimer));
    resetTimer();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach((event) => document.removeEventListener(event, resetTimer));
    };
  }, [isAuthenticated, logout]);
}
